import {useEffect, useState} from 'react';
import {useMutex} from 'react-context-mutex';
import {useDispatch} from 'react-redux';
import {useParams} from 'react-router-dom';
import {unwrapResult} from '@reduxjs/toolkit';

import {useIsMount} from 'shared/lib/hooks/useIsMount';
import {confirmAdditionalEmail} from 'entities/notification';
import {TypedDispatch} from 'shared/model/types';

export const useAdditionalEmailConfirm = () => {
    const dispatch = useDispatch<TypedDispatch>();
    const MutexRunner = useMutex();
    // eslint-disable-next-line react-hooks/exhaustive-deps
    const mutex = new MutexRunner('additionalEmailConfirm');
    const isMount = useIsMount();
    const {token} = useParams<{token: string}>();

    const [message, setMessage] = useState<string>();
    const [status, setStatus] = useState<boolean>(false);

    useEffect(() => {
        if (!token || !isMount) {
            return;
        }
        mutex.run(async() => {
            mutex.lock();
            try {
                const resultAction = await dispatch(confirmAdditionalEmail({token}));

                const response = unwrapResult(resultAction);
                setMessage(response.message);
                setStatus(response.status);
            } catch (error: any) {
                setMessage(error.message);
                setStatus(false);
            } finally {
                mutex.unlock();
            }
        });
    }, [dispatch, isMount, mutex, token]);

    return {message, status};
};

export default useAdditionalEmailConfirm;
